import { tickerItems } from '@/mocks/home';

export default function TopBar() {
  const line = [...tickerItems, ...tickerItems];
  return (
    <div className="w-full">
      <div className="bg-primary-900 text-background-100">
        <div className="mx-auto max-w-[1280px] px-4 md:px-6 h-9 flex items-center justify-between text-xs">
          <div className="flex items-center gap-4">
            <a href="#top" className="hover:text-background-50 transition-colors">
              设为首页
            </a>
            <span className="text-primary-700">|</span>
            <a href="#library" className="hover:text-background-50 transition-colors">
              片库索引
            </a>
            <span className="text-primary-700 hidden sm:inline">|</span>
            <a href="#talk" className="hidden sm:inline hover:text-background-50 transition-colors">
              意见反馈
            </a>
          </div>
          <div className="hidden md:flex items-center gap-4">
            <span className="text-primary-200">2026年10月10日 星期六</span>
            <span className="inline-flex items-center gap-1 text-primary-200">
              <i className="ri-cloud-line" />
              晴 · 适合窝家看片
            </span>
          </div>
        </div>
      </div>
      <div className="bg-secondary-100 border-b border-secondary-200">
        <div className="mx-auto max-w-[1280px] px-4 md:px-6 h-10 flex items-center gap-3 overflow-hidden">
          <span className="shrink-0 inline-flex items-center gap-1 bg-accent-500 text-background-50 text-xs font-semibold px-2.5 py-1 rounded-md">
            <i className="ri-flashlight-fill" />
            快讯
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="marquee-track flex w-max items-center gap-10 whitespace-nowrap">
              {line.map((item, idx) => (
                <span key={idx} className="text-xs md:text-sm text-secondary-900">
                  {item}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}